import { Component, OnInit } from '@angular/core';
import { CrudService } from 'src/app/core/services/global/crud.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor(public crudService: CrudService) { }

  ngOnInit(): void {
  }

}
